import { usePatchPositionClientV2 } from '@/clients/position/positionV2.ts';
import { useMutation } from '@tanstack/react-query';
import { PatchPositionConfigurationRequest } from '@/shared/types/positionV2/api/patch-position-configuration.ts';

function getUsePatchPositionV2QueryKey(positionId: string) {
    return ['patch-position-v2', positionId];
}

export const usePatchPositionV2 = (positionId: string) => {
    const { patchPositionV2 } = usePatchPositionClientV2();

    return useMutation({
        mutationKey: getUsePatchPositionV2QueryKey(positionId),
        mutationFn: async (body: PatchPositionConfigurationRequest) => patchPositionV2(positionId, body),
    });
};
